import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";

/**
 * This react component is a custom version of the ReportsColorIcon svg, with color overrides.
 * TODO - remove this once V5 introduces the ReportsIcon, which can be used in the HeroAssetsIcon instead.
 */
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M8 3.5h7.765v13H8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.8 3.7a.7.7 0 0 1 .7-.7h11a.7.7 0 0 1 .7.7v12.6a.7.7 0 0 1-.7.7h-11a.7.7 0 0 1-.7-.7zm1.4.7v11.2h1.402V4.4zm2.802 0v11.2H14.8V4.4zM9.3 7.117a.7.7 0 0 1 .7-.7h2.555a.7.7 0 1 1 0 1.4H10a.7.7 0 0 1-.7-.7m0 2.961a.7.7 0 0 1 .7-.7h2.555a.7.7 0 0 1 0 1.4H10a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ReportsIcon20.js.map